const CHECKOUT_SCROLL_OFFSET = 16;

interface ScrollToElementOptions {
  onlyIfScrollDown?: boolean;
}

const getHeaderHeight = () =>
  document
    .querySelector('[data-testid="HeaderWrapper"]')
    ?.getBoundingClientRect().height ?? 0;

export const getScrollTopWithHeaderOffset = (element: HTMLElement) => {
  const headerHeight = getHeaderHeight();

  return Math.max(
    0,
    element.getBoundingClientRect().top +
      window.scrollY -
      headerHeight -
      CHECKOUT_SCROLL_OFFSET,
  );
};

export const scrollToElementWithHeaderOffset = (
  element: HTMLElement,
  options?: ScrollToElementOptions,
) => {
  const top = getScrollTopWithHeaderOffset(element);

  if (options?.onlyIfScrollDown && top <= window.scrollY) {
    return;
  }

  window.scrollTo({
    top,
    behavior: 'smooth',
  });
};

export const scrollElementToCenterBelowHeader = (element: HTMLElement) => {
  const headerHeight = getHeaderHeight();
  const { height, top } = element.getBoundingClientRect();
  const centerOffset = Math.max(
    CHECKOUT_SCROLL_OFFSET,
    (window.innerHeight - headerHeight - height) / 2,
  );

  window.scrollTo({
    top: Math.max(0, top + window.scrollY - headerHeight - centerOffset),
    behavior: 'smooth',
  });
};
